import React from "react";

import { Flex, Wrap, Box, Text, Grid, GridItem } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

import { TableButton } from "./Button";

export const TableViewButtons: React.FC = () => {
	const { portfolioParams } = useParams();
	const atPortfolio = portfolioParams === undefined;
	const atInspeccion = location.pathname.includes("inspeccion");
	const atLocalizacion = location.pathname.includes("localizacion");
	const atTipologia = location.pathname.includes("tipologia");
	const atConservacion = location.pathname.includes("nec");
	const atEnergetica = location.pathname.includes("nee");
	const atAccesibilidad = location.pathname.includes("nae");
	const atNormativa = location.pathname.includes("ncn");
	const atCertificacion = portfolioParams === "certificacion";
	const atCertificacionBasica = portfolioParams === "certificacion-basicas";
	const atComunicaciones = location.pathname.includes("comunicaciones");

	return (
		<Grid templateColumns="3fr 4fr 3fr" gap=".5rem 4rem">
			<GridItem colSpan={1}>
				<Box>
					<Text textStyle="body3" color="gray.500">
						Datos generales
					</Text>
				</Box>
			</GridItem>
			<GridItem colSpan={1}>
				<Box>
					<Text textStyle="body3" color="gray.500">
						Categorías de inspección
					</Text>
				</Box>
			</GridItem>
			<GridItem colSpan={1}>
				<Box>
					<Text textStyle="body3" color="gray.500">
						Control de estado
					</Text>
				</Box>
			</GridItem>

			<GridItem colSpan={1}>
				<Flex>
					<Wrap spacing={3}>
						<TableButton name="Inspección" path={atInspeccion || atPortfolio} />
						<TableButton name="Localización" path={atLocalizacion} />
						<TableButton name="Tipología" path={atTipologia} />
					</Wrap>
				</Flex>
			</GridItem>

			<GridItem colSpan={1}>
				<Flex>
					<Wrap spacing={3}>
						<TableButton name="E. Conservación" path={atConservacion} title="Estado de Conservación" />
						<TableButton name="E. Energética" path={atEnergetica} title="Eficiencia Energética" />
						<TableButton name="Accesibilidad" path={atAccesibilidad} title="Accesibilidad" />
						<TableButton name="C. Normativa" path={atNormativa} title="Cumplimiento de Normativa" />
					</Wrap>
				</Flex>
			</GridItem>

			<GridItem colSpan={1}>
				<Flex>
					<Wrap spacing={3}>
						<TableButton name="Certificación" path={atCertificacion} title="Certificación Principal y Según Estado" />
						<TableButton name="Cert. Básica" path={atCertificacionBasica} title="Certificación Básica" />
						<TableButton name="Comunicaciones" path={atComunicaciones} />
					</Wrap>
				</Flex>
			</GridItem>
		</Grid>
	);
};
